export const votingTokenMock = {
  "token": {
      "address": "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
      "name": "Example Token",
      "symbol": "EXT",
      "logoUrl": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GTC.webp",
      "price": 0.26814048780023797,
      "infiniteSupply": false,
      "explorerLink": "https://etherscan.io/token/0xde30da39c46104798bb5aa3fe8b9e0e1f348163f"
  },
  "metrics": {
      "current": {
          "circulatingSupply": 96384727.70514555,
          "circulatingSupplyUSD": 25844647.90335084,
          "totalSupply": 100000000,
          "totalSupplyUSD": 26814048.7800238,
          "numberOfTokenHolders": 92656,
          "tokenPercentOfCirculatingSupply": 14.994867231558166,
          "tokenValue": 14452761.950885436,
          "tokenValueUSD": 4021920.2293226235
      },
      "metrics7DaysAgo": {
          "circulatingSupply": 96384727.70514555,
          "circulatingSupplyUSD": 29238203.156985547,
          "totalSupply": 100000000,
          "totalSupplyUSD": 30334892.107004054,
          "numberOfTokenHolders": 92656,
          "tokenPercentOfCirculatingSupply": 14.994867231558166,
          "tokenValue": 14452761.950885434,
          "tokenValueUSD": 4663845.695386744
      },
      "metrics30DaysAgo": {
          "circulatingSupply": 96384727.70514555,
          "circulatingSupplyUSD": 32175221.389617715,
          "totalSupply": 100000000,
          "totalSupplyUSD": 33382074.272229355,
          "numberOfTokenHolders": 92656,
          "tokenPercentOfCirculatingSupply": 14.994867231558166,
          "tokenValue": 14452761.950885434,
          "tokenValueUSD": 4653738.617841294
      },
      "metrics6MonthsAgo": {
          "circulatingSupply": 95909078.45904586,
          "circulatingSupplyUSD": 29808338.075801555,
          "totalSupply": 100000000,
          "totalSupplyUSD": 31079787.810212374,
          "numberOfTokenHolders": 92656,
          "tokenPercentOfCirculatingSupply": 13.21379818786933,
          "tokenValue": 12673232.071423575,
          "tokenValueUSD": 3953668.215501179
      },
      "metrics1YearAgo": {
          "circulatingSupply": 84404586.26069586,
          "circulatingSupplyUSD": 55220856.55659829,
          "totalSupply": 100000000,
          "totalSupplyUSD": 65424000.04905021,
          "numberOfTokenHolders": null,
          "tokenPercentOfCirculatingSupply": 23.319829429469543,
          "tokenValue": 19683005.54664376,
          "tokenValueUSD": 13028709.715465268
      }
  },
  "updatedAt": "2025-09-30T04:03:29.890Z"
};

export const orgHoldingTokenMock = [
  {
      "organization": {
          "id": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
          "title": "Radicle",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/4c31770a-e3ca-4cc8-9292-508d632ff66a.webp"
      },
      "totalTokenValue": 500000,
      "totalTokenUsd": 139380.01025557143
  },
  {
      "organization": {
          "id": "5e6a7fa1-c5a5-4b77-a3f2-29d236abfb5a",
          "title": "Developer DAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5e6a7fa1-c5a5-4b77-a3f2-29d236abfb5a.webp"
      },
      "totalTokenValue": 25000.010000000002,
      "totalTokenUsd": 6950.5442658281545
  },
  {
      "organization": {
          "id": "11eb10d7-6493-4cfc-8255-cb0f2338fa67",
          "title": "Balancer",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/11eb10d7-6493-4cfc-8255-cb0f2338fa67.webp"
      },
      "totalTokenValue": 20100.102583401775,
      "totalTokenUsd": 6770.192897041255
  },
  {
      "organization": {
          "id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "title": "ENS DAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/228c8be1-9d1e-440c-8afb-a40d6ee480f2.webp"
      },
      "totalTokenValue": 3732.21,
      "totalTokenUsd": 1037.2898072255218
  },
  {
      "organization": {
          "id": "ad0a4d2a-8fa5-483d-b1d1-a4dc7668977b",
          "title": "BanklessDAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/ad0a4d2a-8fa5-483d-b1d1-a4dc7668977b.webp"
      },
      "totalTokenValue": 2957.7388308710233,
      "totalTokenUsd": 822.8745614538443
  },
  {
      "organization": {
          "id": "b6a71d01-6f5a-41c0-96fb-1b04cbf36274",
          "title": "zkSync",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b6a71d01-6f5a-41c0-96fb-1b04cbf36274.webp"
      },
      "totalTokenValue": 1640.0265880688573,
      "totalTokenUsd": 455.8111315769143
  },
  {
      "organization": {
          "id": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
          "title": "Badger DAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fe4cd05c-f6cb-461a-add9-bcdb1365fc0e.webp"
      },
      "totalTokenValue": 1156.5018587903348,
      "totalTokenUsd": 322.38648187756854
  },
  {
      "organization": {
          "id": "239436bf-d864-4b68-ad77-2efa058cbdd6",
          "title": "LexDAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/239436bf-d864-4b68-ad77-2efa058cbdd6.webp"
      },
      "totalTokenValue": 523.8320416968056,
      "totalTokenUsd": 145.63665349225008
  },
  {
      "organization": {
          "id": "9c503621-50a8-4580-bc71-39418b8d4001",
          "title": "Status",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/9c503621-50a8-4580-bc71-39418b8d4001.webp"
      },
      "totalTokenValue": 20,
      "totalTokenUsd": 5.554718152081822
  },
  {
      "organization": {
          "id": "cd4f5467-ed7f-430c-b8da-a4d270dd2971",
          "title": "elimu.ai",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/cd4f5467-ed7f-430c-b8da-a4d270dd2971.webp"
      },
      "totalTokenValue": 1,
      "totalTokenUsd": 0.278511423182782
  },
  {
      "organization": {
          "id": "db953899-a74b-4dfa-b79f-8f4783a9b087",
          "title": "ShapeShift",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/db953899-a74b-4dfa-b79f-8f4783a9b087.webp"
      },
      "totalTokenValue": 0.30234363689735,
      "totalTokenUsd": 0.0842813184229188
  },
  {
      "organization": {
          "id": "4a7784af-e555-4901-b915-63022d22f04d",
          "title": "SushiSwap",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/4a7784af-e555-4901-b915-63022d22f04d.webp"
      },
      "totalTokenValue": 9.766e-15,
      "totalTokenUsd": 2.7176862867487008e-15
  }
];

export const topShareholdersMock = {
  "shareholders": [
      {
          "address": "0xf977814e90da44bfa03b6295a0616a897441acec",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 27123938.898,
          "tokenSharesPercentage": 27.1143446614293,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x57a8865cfb1ecef7253c27da6b4bc3daee5be518",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 14095413.739304138,
          "tokenSharesPercentage": 14.090427931951993,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x14d7cee42d4643f0c767a1d504d9ca24c890f86c",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 3989750.3611465897,
          "tokenSharesPercentage": 3.9883391129880237,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x13975cfa0a3bb9e0ec27cbafa7f2ddc5e5e352cb",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 3572000.0000000005,
          "tokenSharesPercentage": 3.5707365178354293,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x28c6c06298d514db089934071355e5743bf21d60",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 3466656.788347226,
          "tokenSharesPercentage": 3.465430568016105,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x5a52e96bacdabb82fd05763e25335261b270efcb",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 2857462.553,
          "tokenSharesPercentage": 2.8564518158858774,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x74be0cf1c9972c00ed4ef290e0e5bcfd18873f13",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 2110824.155394249,
          "tokenSharesPercentage": 2.1100775180278197,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x931896a8a9313f622a2afca76d1471b97955e551",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 2095432.6940898332,
          "tokenSharesPercentage": 2.094691500966641,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x2cde9919e81b20b4b33dd562a48a84b54c48f00c",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 1765000,
          "tokenSharesPercentage": 1.764375687004348,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x7dae0a882bd4511fa6918e6a35b21ad31a89e3ab",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 1258850.6112062407,
          "tokenSharesPercentage": 1.2584053325681896,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x885e84b7d671475dc3b5f90c5ea9ff2e9a035540",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 1210741.036021408,
          "tokenSharesPercentage": 1.2103127746258515,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x0e3efd5be54cc0f4c64e0d186b0af4b7f2a0e95f",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 1148816.7229843119,
          "tokenSharesPercentage": 1.1484103653583737,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x3896ab65f7191a446f5ba550a92f9fbe5dd658af",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 1118544.735312164,
          "tokenSharesPercentage": 1.118149085445607,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x2aa5d15eb36e5960d056e8fea6e7bb3e2a06a351",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 968796.8974600001,
          "tokenSharesPercentage": 0.9684542161607188,
          "name": null,
          "avatar": null
      },
      {
          "address": "0xe527bbde3654e9ba824f9b72dff495eee60fd366",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 937496,
          "tokenSharesPercentage": 0.9371643904044354,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x7ad3d9819b06e800f8a65f3440d599a23d6a0bdf",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 853994.3800000001,
          "tokenSharesPercentage": 0.8536923064647891,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x21427396e2b6259c1b1def4052d5dee3526cde17",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 725513.0333480776,
          "tokenSharesPercentage": 0.7252564060306647,
          "name": null,
          "avatar": null
      },
      {
          "address": "0xb1b27556b9afd823374441b032b1e104a25aa702",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 722216.9872323902,
          "tokenSharesPercentage": 0.7219615257871723,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x2cc8e1d628a9a3aa87708f3937c8c6866f4f0037",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 715334.5771861864,
          "tokenSharesPercentage": 0.7150815501761149,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x1e11e937905326960fd92fb51040e520862efa6b",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 709665.4601182897,
          "tokenSharesPercentage": 0.7094144383793,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x1e299e3f6e9f88c9e00a79801bf2a2078d150fcf",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 709665.4601182897,
          "tokenSharesPercentage": 0.7094144383793,
          "name": null,
          "avatar": null
      },
      {
          "address": "0x8d39baf96d96594f91529a73a499f9c59e7fe748",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 709665.4601182897,
          "tokenSharesPercentage": 0.7094144383793,
          "name": null,
          "avatar": null
      },
      {
          "address": "0xa003ec8523894ffe2ae6d0aa20854058a6ad9420",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 709665.4601182897,
          "tokenSharesPercentage": 0.7094144383793,
          "name": null,
          "avatar": null
      },
      {
          "address": "0xa3a1596ce23ce00228c2b07e6940d7d7cec2a6c6",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 709665.4601182897,
          "tokenSharesPercentage": 0.7094144383793,
          "name": null,
          "avatar": null
      },
      {
          "address": "0xf35d6ae94965549148e427b8884968b189d8ab0f",
          "daoId": "6ccc01bb-6a94-41c8-895f-109638e43fb6",
          "votesCount": 0,
          "proposalsCount": 0,
          "memberBalance": 684998,
          "tokenSharesPercentage": 0.68475570359581,
          "name": null,
          "avatar": null
      }
  ]
};

export const tokenPrVsVotesGraphMock = {
  "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
  "data": [
      {
          "date": "2024-10",
          "votes": 1223,
          "avgPrice": 0.6956440956559449,
          "proposals": 1,
          "avgVotesPerProposal": 1223,
          "successfulProposals": 0
      },
      {
          "date": "2024-11",
          "votes": 331,
          "avgPrice": 0.7273422437436291,
          "proposals": 1,
          "avgVotesPerProposal": 331,
          "successfulProposals": 0
      },
      {
          "date": "2024-12",
          "votes": 2180,
          "avgPrice": 0.9996663693115186,
          "proposals": 2,
          "avgVotesPerProposal": 1090,
          "successfulProposals": 0
      },
      {
          "date": "2025-01",
          "votes": 4351,
          "avgPrice": 0.6653759495036814,
          "proposals": 6,
          "avgVotesPerProposal": 725,
          "successfulProposals": 2
      },
      {
          "date": "2025-02",
          "votes": 4503,
          "avgPrice": 0.4327418464681402,
          "proposals": 7,
          "avgVotesPerProposal": 642,
          "successfulProposals": 2
      },
      {
          "date": "2025-03",
          "votes": 997,
          "avgPrice": 0.3618900149902681,
          "proposals": 1,
          "avgVotesPerProposal": 997,
          "successfulProposals": 1
      },
      {
          "date": "2025-04",
          "votes": 2429,
          "avgPrice": 0.27642506040672377,
          "proposals": 5,
          "avgVotesPerProposal": 481,
          "successfulProposals": 3
      },
      {
          "date": "2025-05",
          "votes": 189,
          "avgPrice": 0.30505760179871083,
          "proposals": 1,
          "avgVotesPerProposal": 32,
          "successfulProposals": 1
      },
      {
          "date": "2025-06",
          "votes": 38,
          "avgPrice": 0.24163161899673236,
          "proposals": 0,
          "avgVotesPerProposal": 0,
          "successfulProposals": 0
      },
      {
          "date": "2025-07",
          "votes": 782,
          "avgPrice": 0.2919251530075885,
          "proposals": 1,
          "avgVotesPerProposal": 782,
          "successfulProposals": 1
      },
      {
          "date": "2025-08",
          "votes": 1467,
          "avgPrice": 0.31965974142759784,
          "proposals": 2,
          "avgVotesPerProposal": 734,
          "successfulProposals": 1
      },
      {
          "date": "2025-09",
          "votes": 1311,
          "avgPrice": 0.32605799857339635,
          "proposals": 1,
          "avgVotesPerProposal": 735,
          "successfulProposals": 0
      }
  ],
  "updatedAt": "2024-10-14T19:38:46.192Z"
}
